import Layout from "app/components/Layout";
import PrivateRoute from "app/components/PrivateRoute";
import { RouteObject } from "react-router-dom";
import MobileChannelList from "./ChannelList";

export const MobileChatLayout: RouteObject[] = [
  {
    path: "/chat",
    element: (
      <PrivateRoute>
        <Layout>
          <MobileChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/chat/:sid/:avatar/:name/:myavatar",
    element: (
      <PrivateRoute>
        <Layout>
          <MobileChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/chat/:sid",
    element: (
      <PrivateRoute>
        <Layout>
          <MobileChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },
];
